var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7091_18973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 17.334H7.33366C6.96547 17.334 6.66699 17.6325 6.66699 18.0007V20.6673C6.66699 21.0355 6.96547 21.334 7.33366 21.334H10.0003C10.3685 21.334 10.667 21.0355 10.667 20.6673V18.0007C10.667 17.6325 10.3685 17.334 10.0003 17.334Z",
    fill: "#A2A8B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 10.6667H7.33301C7.1562 10.6667 6.98663 10.7369 6.8616 10.8619C6.73658 10.987 6.66634 11.1565 6.66634 11.3333V12.1333H3.86634V8H4.66634C4.84315 8 5.01272 7.92976 5.13775 7.80474C5.26277 7.67971 5.33301 7.51014 5.33301 7.33333V4.66667C5.33301 4.48986 5.26277 4.32029 5.13775 4.19526C5.01272 4.07024 4.84315 4 4.66634 4H1.99967C1.82286 4 1.65329 4.07024 1.52827 4.19526C1.40325 4.32029 1.33301 4.48986 1.33301 4.66667V7.33333C1.33301 7.51014 1.40325 7.67971 1.52827 7.80474C1.65329 7.92976 1.82286 8 1.99967 8H2.79967V19.8667H7.33301C7.47446 19.8667 7.61011 19.8105 7.71013 19.7105C7.81015 19.6104 7.86634 19.4748 7.86634 19.3333C7.86634 19.1919 7.81015 19.0562 7.71013 18.9562C7.61011 18.8562 7.47446 18.8 7.33301 18.8H3.86634V13.2H6.66634V14C6.66634 14.1768 6.73658 14.3464 6.8616 14.4714C6.98663 14.5964 7.1562 14.6667 7.33301 14.6667H9.99967C10.1765 14.6667 10.3461 14.5964 10.4711 14.4714C10.5961 14.3464 10.6663 14.1768 10.6663 14V11.3333C10.6663 11.1565 10.5961 10.987 10.4711 10.8619C10.3461 10.7369 10.1765 10.6667 9.99967 10.6667Z",
    fill: "#A2A8B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0003 5.33398H6.66699V6.66732H22.0003C22.1771 6.66732 22.3467 6.59708 22.4717 6.47206C22.5968 6.34703 22.667 6.17746 22.667 6.00065C22.667 5.82384 22.5968 5.65427 22.4717 5.52925C22.3467 5.40422 22.1771 5.33398 22.0003 5.33398Z",
    fill: "#A2A8B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12H12V13.3333H22C22.1768 13.3333 22.3464 13.2631 22.4714 13.1381C22.5964 13.013 22.6667 12.8435 22.6667 12.6667C22.6667 12.4899 22.5964 12.3203 22.4714 12.1953C22.3464 12.0702 22.1768 12 22 12Z",
    fill: "#A2A8B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 18.666H12V19.9993H22C22.1768 19.9993 22.3464 19.9291 22.4714 19.8041C22.5964 19.6791 22.6667 19.5095 22.6667 19.3327C22.6667 19.1559 22.5964 18.9863 22.4714 18.8613C22.3464 18.7363 22.1768 18.666 22 18.666Z",
    fill: "#A2A8B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7091_18973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/tree.a3f21887006aafdaacc0bc8c31538a6f.svg";
export { ForwardRef as ReactComponent };